<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17BW9Kx/tc-custom/9781684810291.jpg?1728353491934" alt="This image is the cover for the book Nothing's Wrong"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nothing's Wrong
      </h1>
      <p class="bookDescription body article font2">
        <b>Men, It’s Time to Master your Emotions</b><p><b>Too often Men are told to bottle up how they feel which leads to emotional numbness. Men, take the reins back and master your emotions with this guide to emotional healing.</b></p><p><b>Every man has a deep bed of emotions.</b> Emotions and feelings shouldn’t be ignored. To get the great and healthy relationships you desire, you need to change the way that you manage your emotions. David Kundtz has created this full guide to steer you towards emotional healing.</p><p><b>Men, master your emotions. </b>Emotions are diverse, learn all of different ways to spot your emotions and how to better express emotions. Become comfortable with your emotions, tune in to the emotions around you, and learn good communication skills. </p><p><b>Men, this book is for you. </b>This motivational book is dedicated to teenage boys, young men, fathers, and grandfathers. Build your emotional confidence and your communication skills. The language, tools, and the exercises inside of this book are designed to help you express the deep, vibrant and ever-present emotions that you hold inside of you. </p><p><b>Nothing’s Wrong is packed with:</b></p>Processes to identify and master your emotionsInformation for teenage boys, young men, fathers, and grandfathers Tips and Tools to aide you on your path towards emotional healing<p></p><p><b>If you enjoyed motivational books like <i>Cry Like A Man</i>, <i>Master Your Emotions</i>, or <i>The Mental Toughness</i>, then you’ll love <i>Nothing’s Wrong</i>.</b></p><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Kundtz
      </h2>
      
      <p class="authorDescription body article"><P><B>David Kundtz</B> has enjoyed several careers, including eighteen years in religious ministry and twenty years in the practice of psychotherapy, public speaking on stress and emotional health, and writing. He has graduate degrees in psychology and theology and a doctorate in pastoral psychology. He is the author of <I>Quiet Mind</I>, <I>Stopping</I>, <I>Moments in Between</I>, <I>Awakened Mind</I>, and several other books.<br></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mango Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32d03a1e